'use client';

import React from 'react';
import { withOptionalId } from '@lib/withOptionalId';

type Props = React.HTMLAttributes<HTMLElement> & {
  sectionID?: string;
  children: React.ReactNode;
};

const Section: React.FC<Props> = ({ sectionID, className, children, ...rest }) => {
  const trimmed = className?.trim();
  const classes = trimmed || undefined;
  return (
    <section {...withOptionalId(sectionID)} className={classes} {...rest}>
      {children}
    </section>
  );
};

export default Section;
